import { IFieldState } from './applicationFormTypes';

export const APPLICANT_AGE_CHILD_FIELD_PREFIX = 'applicantAgeChild';

/**
 * UI-only field driving how many numeric per-child age inputs the DK life-situation
 * page renders. It has no corresponding credit attribute and must never reach the
 * submission payload - see stripUiOnlyChildFields.
 */
export const CHILD_COUNT_SELECTOR_FIELD_NAME = 'numberOfChildrenSelector';

/** Matches the 10 applicantAgeChild1-10 credit-attribute slots. */
export const MAX_CHILDREN = 10;

/** Bounds for the per-child age input. */
export const MIN_CHILD_AGE = 0;
export const MAX_CHILD_AGE = 99;

const clampChildCount = (childCount: number): number => Math.min(Math.max(childCount, 0), MAX_CHILDREN);

const currentChildFieldNames = (childCount: number): Set<string> =>
    new Set(
        Array.from({ length: clampChildCount(childCount) }, (_, index) => `${APPLICANT_AGE_CHILD_FIELD_PREFIX}${index + 1}`),
    );

/**
 * The DK life-situation page collects one raw age per child under the credit
 * attributes applicantAgeChild1-10. Fields beyond the current child count (stale ages
 * left over from a higher count that was since lowered) and the UI-only child-count
 * field itself are dropped before submission, since neither is a credit attribute the
 * backend expects.
 */
export const stripUiOnlyChildFields = (fieldStates: IFieldState[]): IFieldState[] => {
    const countField = fieldStates.find((fieldState) => fieldState.fieldName === CHILD_COUNT_SELECTOR_FIELD_NAME);
    const childCount = Number(countField?.value) || 0;
    const relevantFieldNames = currentChildFieldNames(childCount);

    return fieldStates.filter(
        (fieldState) =>
            fieldState.fieldName !== CHILD_COUNT_SELECTOR_FIELD_NAME &&
            (!fieldState.fieldName.startsWith(APPLICANT_AGE_CHILD_FIELD_PREFIX) ||
                relevantFieldNames.has(fieldState.fieldName)),
    );
};
